import { createRouter, createWebHistory } from 'vue-router';

import lib from '@/lib';

import LayoutAdmin from '@/layouts/LayoutAdmin';
import LayoutEditor from '@/layouts/LayoutEditor';
import LayoutExam from '@/layouts/LayoutExam';
import LayoutEmpty from '@/layouts/LayoutEmpty';

import ExamLogin from '@/pages/exam/Login';
import ExamSelect from '@/pages/exam/Select';
import ExamDo from '@/pages/exam/Do';

import AdminLogin from '@/pages/admin/Login';
import AdminMain from '@/pages/admin/Main';
import AdminSettings from '@/pages/admin/Settings';
import AdminExams from '@/pages/admin/Exams';
import AdminExamsArchive from '@/pages/admin/ExamsArchive';
import AdminExamsStudents from '@/pages/admin/ExamsStudents';
import AdminSpecialities from '@/pages/admin/Specialities';
import AdminQualifications from '@/pages/admin/Qualifications';
import AdminDisciplines from '@/pages/admin/Disciplines';
import AdminQuestions from '@/pages/admin/Questions';
import AdminOrganizations from '@/pages/admin/Organizations';
import AdminStudentsGroups from '@/pages/admin/StudentsGroups';
import AdminStudents from '@/pages/admin/Students';

import EditorLogin from '@/pages/editor/Login';
import EditorMain from '@/pages/editor/Main';
import EditorSpecialities from '@/pages/editor/Specialities';
import EditorQualifications from '@/pages/editor/Qualifications';
import EditorDisciplines from '@/pages/editor/Disciplines';
import EditorQuestions from '@/pages/editor/Questions';
import EditorStudentsGroups from '@/pages/editor/StudentsGroups';
import EditorStudents from '@/pages/editor/Students';

import PageNotFound from '@/pages/PageNotFound';

const routes = [
	/*{
		path: '/',
		redirect: '/exam',
	},*/
	{
		path: '/login',
		component: LayoutEmpty,
		children: [
			{
				path: '',
				component: ExamLogin,
				meta: {
					guest: true,
				},
			},
			{
				path: '/admin/login',
				component: AdminLogin,
				meta: {
					guest: true,
				},
			},
			{
				path: '/editor/login',
				component: EditorLogin,
				meta: {
					guest: true,
				},
			},
			{
				path: '/',
				component: ExamSelect,
				meta: {
					requiresAuth: true,
					student: true,
				},
			},
		],
	},
	{
		path: '/admin',
		component: LayoutAdmin,
		children: [
			{
				path: '',
				component: AdminMain,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/settings',
				component: AdminSettings,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/exams',
				component: AdminExams,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/exams-archive',
				component: AdminExamsArchive,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/exams/:exam_id/students',
				component: AdminExamsStudents,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/exams-archive/:exam_id/students',
				component: AdminExamsStudents,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/specialities',
				component: AdminSpecialities,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/specialities/:speciality_id/qualifications',
				component: AdminQualifications,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/disciplines',
				component: AdminDisciplines,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/disciplines/:discipline_id/questions',
				component: AdminQuestions,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/organizations',
				component: AdminOrganizations,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/students-groups',
				component: AdminStudentsGroups,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/students-groups/:group_id/students',
				component: AdminStudents,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
		],
	},
	{
		path: '/editor',
		component: LayoutEditor,
		children: [
			{
				path: '',
				component: EditorMain,
				meta: {
					requiresAuth: true,
					editor: true,
				},
			},
			{
				path: '/editor/specialities',
				component: EditorSpecialities,
				meta: {
					requiresAuth: true,
					editor: true,
				},
			},
			{
				path: '/editor/specialities/:speciality_id/qualifications',
				component: EditorQualifications,
				meta: {
					requiresAuth: true,
					editor: true,
				},
			},
			{
				path: '/editor/disciplines',
				component: EditorDisciplines,
				meta: {
					requiresAuth: true,
					editor: true,
				},
			},
			{
				path: '/editor/disciplines/:discipline_id/questions',
				component: EditorQuestions,
				meta: {
					requiresAuth: true,
					editor: true,
				},
			},
			{
				path: '/editor/students-groups',
				component: EditorStudentsGroups,
				meta: {
					requiresAuth: true,
					editor: true,
				},
			},
			{
				path: '/editor/students-groups/:group_id/students',
				component: EditorStudents,
				meta: {
					requiresAuth: true,
					editor: true,
				},
			},
		],
	},
	{
		path: '/exam',
		component: LayoutExam,
		children: [
			{
				path: '',
				component: ExamDo,
				meta: {
					requiresAuth: true,
					student: true,
				},
			},
		],
	},
	{
		path: '/logout',
		beforeEnter(to, from, next){
			const isAdmin = storeInstance.state.app.auth.isAdmin();
			const isEditor = storeInstance.state.app.auth.isEditor();
			storeInstance.state.app.auth.doLogout().then(() => {
				if(isAdmin){
					next({path: '/admin/login'});
				} else if(isEditor){
					next({path: '/editor/login'});
				} else {
					next({path: '/login'});
				}
			});
		},
	},
	{
		path: '/:pathMatch(.*)*',
		component: LayoutEmpty,
		children: [
			{
				path: '',
				component: PageNotFound,
			},
		],
	},
	{
		path: '/:pathMatch(.*)',
		component: LayoutEmpty,
		children: [
			{
				path: '',
				component: PageNotFound,
			},
		],
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.beforeEach((to, from, next) => {
	storeInstance.state.app.auth.doInitData().then(() => {
		if(to.matched.some(record => record.meta.requiresAuth)){
			if(!storeInstance.state.app.auth.isAuth()){
				if(to.matched.some(record => record.meta.admin)){
					next({
						path: '/admin/login',
						params: {
							nextUrl: to.fullPath,
						},
					})
				} else if(to.matched.some(record => record.meta.editor)){
					next({
						path: '/editor/login',
						params: {
							nextUrl: to.fullPath,
						},
					})
				} else {
					next({
						path: '/login',
						params: {
							nextUrl: to.fullPath,
						},
					})
				}
			} else {
				const isAdmin = storeInstance.state.app.auth.isAdmin();
				const isEditor = storeInstance.state.app.auth.isEditor();
				const isStudent = storeInstance.state.app.auth.isStudent();
				if(to.matched.some(record => record.meta.admin)){
					if(isAdmin){
						next()
					} else {
						next(isEditor ? '/editor' : '/')
					}
				} else if(to.matched.some(record => record.meta.editor)){
					if(isEditor){
						next()
					} else {
						next(isAdmin ? '/admin' : '/')
					}
				} else if(to.matched.some(record => record.meta.student)){
					if(isStudent){
						next()
					} else {
						next(isAdmin ? '/admin' : isEditor ? '/editor' : '/')
					}
				} else {
					next()
				}
			}
		} else if(to.matched.some(record => record.meta.guest)){
			if(storeInstance.state.app.auth.isAuth()){
				next('/')
			} else {
				next()
			}
		} else {
			next() 
		}
	});
});

export default router;